export default [
    {
        path: '/profile/resume',
        name: 'profile-resume',
        component: () => import(/* webpackChunkName: "profile-resume" */ '../views/ProfileResume.vue'),
        meta: {
            requiresAuth: true
        }
    },

    {
        path: '/profile/privacy',
        name: 'profile-privacy',
        component: () => import(/* webpackChunkName: "profile-privacy" */ '../views/ProfilePrivacy.vue'),
        meta: {
            requiresAuth: true
        }
    },

    {
        path: '/profile/change-password',
        name: 'profile-change-password',
        component: () => import(/* webpackChunkName: "profile-change-password" */ '../views/ProfileChangePassword.vue'),
        meta: {
            requiresAuth: true
        }
    },
]

